var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mr-5 my-3 pa-2 grey--text text--darken-3",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"grey--text text--darken-3 mx-auto"},[(_setup.props.chartdata)?_c(_setup.PacketPerDayBarGraph,{attrs:{"chartdata":_setup.props.chartdata}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }